import { ControleSection } from './Controle'
import { ExportacaoFolha } from './ExportacaoFolha'
import { PontoWeb } from './PontoWeb'
import { RelogioPonto } from './RelogioPonto'
import { Seguranca } from './Seguranca'

export function AdicionaisForm() {
    return (
        <section id="adicionais">
            <ControleSection />
            <PontoWeb />
            <ExportacaoFolha />
            <RelogioPonto />
            <Seguranca />
            <div className="h-16" />
        </section>
    )
}
